import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import PhieuInChiTiet from "./PhieuInChiTiet";

const BtnInChiTiet = ({ item }) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <a
        onClick={handlePrint}
        className="iconTableMorman"
        title="In phiếu thu"
      >
        <i className="la la-print"></i>
      </a>

      <div style={{ display: "none" }}>
        <PhieuInChiTiet ref={componentRef} item={item} />
      </div>
    </>
  );
};
export default BtnInChiTiet;